  <div *ngIf="!selectionService.selection.selected.length" class="ddlLabel">No Documents Selected</div>
  <mat-form-field>
    <mat-label>--- Add Docs to Archive Job ---</mat-label>
    <mat-select (selectionChange)="addDocs($event)" [disabled]="!selectionService.selection.selected.length">
      <mat-option *ngFor="let archiveJob of archiveJobs" [value]="archiveJob">{{archiveJob.title}}</mat-option>
    </mat-select>
  </mat-form-field>
